import { FC } from 'react';
import { Typography } from '@mui/material';
import { COLORS } from 'services/constants/colors';
import { TAmountAndCurrencyProps } from './types';

export const AmountAndCurrency: FC<TAmountAndCurrencyProps> = ({
	amount,
	currency = 'EUR',
	size = 0.875,
	color = COLORS.font_main,
	bold = 'normal',
	type = 'ISO',
	afterPoint = 2,
	noFixedPoint = false,
}) => {
	const numericAmount = Number.isFinite(Number(amount)) ? Number(amount) : 0;
	const fixed = noFixedPoint ? numericAmount.toString() : numericAmount.toFixed(afterPoint);
	const amountArray = noFixedPoint
		? [fixed]
		: (fixed.startsWith('-') && parseFloat(fixed) === 0 ? fixed.slice(1) : fixed).split('.');
	return (
		<Typography component="span">
			<Typography
				component="span"
				color={color}
				sx={{
					fontSize: `${size}rem`,
					// color,
					// fontWeight: bold,
				}}
			>
				{type === 'symbol' ? (
					<span
						style={{
							fontFamily: 'Arial',
						}}
					>
						{
							new Intl.NumberFormat('en-EN', { style: 'currency', currency }).format(
								+amountArray[0],
							)[0]
						}
					</span>
				) : (
					''
				)}
				{noFixedPoint ? amountArray[0] : new Intl.NumberFormat('en').format(+amountArray[0])}
				{afterPoint > 0 && !noFixedPoint && '.'}
				<Typography
					component="span"
					sx={{
						fontSize: afterPoint === 2 ? `${size * 0.85}rem` : `${size}rem`,
						color,
						// fontWeight: bold,
					}}
				>
					{amountArray[1]}
				</Typography>
			</Typography>
			{type === 'ISO' && (
				<>
					<Typography
						component="span"
						color={color}
						sx={{
							fontSize: `${size * 0.85}rem`,
							// color,
							opacity: 0.8,
							// fontWeight: bold,
							marginLeft: '2px',
						}}
					>
						{currency}
					</Typography>
				</>
			)}
		</Typography>
	);
};
